// src/environments/environment.dev.ts

import { EnvName } from '@enums/environment.enum';
import packageInfo from '../../package.json';

//const baseUrl = 'https://hoteldirect-backend-devtest.azurewebsites.net/api/v1/';

export const environment = {
  production: false,
  version: packageInfo.version,
  appName: 'EasyAngular',
  envName: EnvName.DEV,
  defaultLanguage: 'en',
  APP_ID: 'Staysconnect_651e916261ed0',
  APP_KEY: 'Staysconnect_651e916261ed5',
  pmsEnabled: false
  //apiBaseUrl: baseUrl,
};
